import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router";
import useRouteStatus from "../../hooks/route-status";
import ForgotPage from "../forgot-password-page/ForgotPasswordPage";
import InvitationPage from "../invitation-page/InvitationPage";
import LoginPage from "../login-page/LoginPage";
import loginPageSlice from "../login-page/store/slice";
import MaintenanceCover from "../maintenance-cover/MaintenanceCover";
import ResetPasswordPage from "../reset-password-page/ResetPasswordPage";
import UpdateBar from "../update-bar/UpdateBar";
import Content from "./content/Content";
import Header from "./header/Header";
import RegisterPage from "../register-page/RegisterPage";

const Layout = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { isPublicRoute } = useRouteStatus();

  const navigate = useNavigate();

  const isLoggedIn = useSelector((state) => state.loginPage.isLoggedIn);
  const isUpdateBarVisible = useSelector((state) => state.updateBar.isVisible);
  const isMaintenanceCoverVisible = useSelector(
    (state) => state.maintenanceCover.isVisible
  );

  const token = localStorage.getItem("token");

  const autoLogin = useCallback(
    () => dispatch(loginPageSlice.actions.autoLogin()),
    [dispatch]
  );

  useEffect(() => {
    if (isLoggedIn && isPublicRoute) {
      navigate("/bookings");
    }
  }, [isLoggedIn, isPublicRoute, navigate]);

  useEffect(() => {
    if (!isLoggedIn && token) {
      autoLogin();
    }
  }, [isLoggedIn, autoLogin, token]);

  const PublicPage = useMemo(() => {
    if (pathname.includes("forgot-password")) {
      return ForgotPage;
    }

    if (pathname.includes("reset-password")) {
      return ResetPasswordPage;
    }

    if (pathname.includes("invitation")) {
      return InvitationPage;
    }

    if (pathname.includes("register")) {
      return RegisterPage;
    }

    return LoginPage;
  }, [pathname]);

  if (isMaintenanceCoverVisible) {
    return <MaintenanceCover />;
  }

  return (
    <>
      {isUpdateBarVisible && <UpdateBar />}
      <Header />
      <Content>{isLoggedIn ? <Outlet /> : <PublicPage />}</Content>
    </>
  );
};

export default Layout;
